@if (loading) {
  <div class="loading-container">
    <mat-spinner [diameter]="40"></mat-spinner>
    <b class="ms-4">{{loginDescription}}</b>
  </div>
}
@if (error != null) {
  <div class="p-4">
    <h4 class="primary-color">{{'OAUTH.ERROR.TITLE' | translate}}</h4>
    <p>{{'OAUTH.ERROR.DESCRIPTION' | translate}}</p>
    @if (invalidCodeMessage) {
      <p>Error: {{error}}</p>
    }
    <button mat-stroked-button color="primary" (click)="authService.logout()">{{'OAUTH.LOGIN_BTN' | translate}}</button>
  </div>
}
